import React from 'react';
import { Badge } from '../../components/ui/Badge';
import type { AggregatorStatus } from '../../api/aggregators';

export const naira = (n: number) =>
  `₦${n.toLocaleString('en-NG', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const date = (iso: string) =>
  new Date(iso).toLocaleDateString('en-NG', { day: 'numeric', month: 'short', year: 'numeric' });

export const th: React.CSSProperties = {
  padding: '12px 14px',
  textAlign: 'left',
  fontSize: 12,
  color: 'var(--neutral-600)',
  textTransform: 'uppercase',
  letterSpacing: 0.4,
};

export const td: React.CSSProperties = { padding: '12px 14px', verticalAlign: 'top' };

export const sectionTitle: React.CSSProperties = { margin: '0 0 6px', fontSize: 15, color: 'var(--neutral-900)' };

export const sectionNote: React.CSSProperties = {
  margin: '0 0 16px',
  fontSize: 13,
  color: 'var(--neutral-600)',
  maxWidth: 680,
};

export const StatusBadge: React.FC<{ status: AggregatorStatus }> = ({ status }) =>
  status === 'active' ? (
    <Badge variant="success">Active</Badge>
  ) : status === 'suspended' ? (
    <Badge variant="warning">Suspended</Badge>
  ) : (
    <Badge variant="danger">Revoked</Badge>
  );

export const SOURCE_LABELS: Record<string, string> = {
  transfer_markup: 'Transfer fees',
  vas_commission: 'Airtime and bills',
  subscription: 'Plan payment',
  message_fees: 'SMS and WhatsApp',
};

/** One line of history, in words. */
export function eventText(kind: string, detail: Record<string, unknown> | null): string {
  const reason = typeof detail?.reason === 'string' ? `: ${detail.reason}` : '';
  switch (kind) {
    case 'approved':
      return `Approved at ${String(detail?.commissionPercent ?? '?')}%`;
    case 'rate_changed':
      return `Rate changed from ${String(detail?.from)}% to ${String(detail?.to)}%${
        typeof detail?.note === 'string' && detail.note ? `: ${detail.note}` : ''
      }`;
    case 'withdrawals_paused':
      return `Withdrawals paused${reason}`;
    case 'withdrawals_resumed':
      return 'Withdrawals resumed';
    case 'suspended':
      return `Suspended${reason}`;
    case 'reinstated':
      return 'Reinstated';
    case 'revoked':
      return `Revoked${reason}`;
    case 'business_cleared':
      return 'A flagged business was cleared';
    case 'business_blocked':
      return 'A flagged business was blocked';
    case 'business_assigned':
      return 'A business was credited to them by hand';
    default:
      return kind;
  }
}
